import { getChartLabel } from "./chartLabel";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";
//kpi 8
const Syphilis = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "place", // default sort by place
    direction: "asc",
  });

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const syphilisData = data.map((item) => {
    return {
      place: item.Place,
      total_screened_for_syphilis: Number(
        item.total_persons_screened_for_syphilis,
      ),
      reactive: Number(item.syphilis_reactive),
      treated: Number(item.syphilis_treated),
      treatmentgap: Number(item.treatment_gap),
      percentage_positive: Number(item.percentage_syphilis_positivity),
      percentage_treated: Number(item.percentage_syphilis_treated),
    };
  });

  const sortedData = [...syphilisData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Handle sorting click
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  // Icon display function
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⬍"; // default icon
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
   if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(syphilisData.length);
  const chunkedData = chunkArray(syphilisData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5>Syphilis Management {getChartLabel(filters, selectedState)}</h5>
 
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        // Table View
        <>
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("total")}
                  >
                    Total no. of individuals screened for Syphilis{" "}
                    {getSortIcon("total")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("reactive")}
                  >
                    Syphilis Reactive {getSortIcon("reactive")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("reactive")}
                  >
                    Syphilis Treated {getSortIcon("reactive")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("treated")}
                  >
                    Treatment Gap {getSortIcon("treatmentgap")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("percentage_positive")}
                  >
                    Percentage of Syphilis Positivity{" "}
                    {getSortIcon("percentage_positive")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("percentage_treated")}
                  >
                    Percentage of Treated for Syphilis{" "}
                    {getSortIcon("percentage_treated")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>
                    <td>{item.total_screened_for_syphilis}</td>
                    <td>{item.reactive}</td>
                    <td>{item.treated}</td>
                    <td>{item.treatmentgap}</td>
                    <td>{item.percentage_positive}%</td>
                    <td>{item.percentage_treated}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        //chart view
        <div>
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Total number of individuals screened for syphilis
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    //stroke="#8884d8"
                    label={{
                      value: "",
                      angle: -90,
                      position: "outside",
                      offset: -100,
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={["total"]} />}
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="total_screened_for_syphilis"
                    fill="#dd1e47"
                    name="Total no. of individuals screened for Syphilis"
                  >
                    <LabelList
                      dataKey="total_screened_for_syphilis"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {/* <div className="card hptCard mt-4 border-0">
            <div className="card-body">
              <h6
                style={{
                  fontWeight: "bold",
                }}
              >
                Syphilis Reactive
              </h6>
            </div>
            <ResponsiveContainer width="100%" height={500}>
              <BarChart
                width={500}
                height={500}
                data={syphilisData}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 130,
                }}
              >
               
                <XAxis
                  dataKey="place"
                  angle={-90}
                  textAnchor="end"
                  interval={0}
                  label={{
                    value: "",
                    position: "insideBottom",
                    offset: -110,
                    color: "#ca8282ff",
                    fontWeight: "bold",
                  }}
                />
                <YAxis
                  yAxisId="left"
                  orientation="left"
                  //stroke="#8884d8"
                  label={{
                    value: "",
                    angle: -90,
                    position: "outside",
                    offset: -100,
                  }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend
                  verticalAlign="top"
                  content={<CustomLegend order={["reactive"]} />}
                />
                <Bar
                  yAxisId="left"
                  dataKey="reactive"
                  fill="#00a084"
                  name="Syphilis Reactive"
                >
                  <LabelList dataKey="reactive" position="top" />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div> */}
          {/* <div className="card hptCard mt-4 border-0">
            <div className="card-body">
              <h6
                style={{
                  fontWeight: "bold",
                }}
              >
                Percentage of Syphilis Positivity
              </h6>
            </div>
            <ResponsiveContainer width="100%" height={500}>
              <BarChart
                width={500}
                height={500}
                data={syphilisData}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 130,
                }}
              >
                
                <XAxis
                  dataKey="place"
                  angle={-90}
                  textAnchor="end"
                  interval={0}
                  label={{
                    value: "",
                    position: "insideBottom",
                    offset: -110,
                    color: "#ca8282ff",
                    fontWeight: "bold",
                  }}
                />
                <YAxis
                  yAxisId="left"
                  orientation="left"
                  //stroke="#8884d8"
                  label={{
                    value: "",
                    angle: -90,
                    position: "outside",
                    offset: -100,
                  }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend
                  verticalAlign="top"
                  content={<CustomLegend order={["percentage_positive"]} />}
                />
                <Bar
                  yAxisId="left"
                  dataKey="percentage_positive"
                  fill="#dd1e47"
                  name="Percentage of Syphilis Positive"
                >
                  <LabelList dataKey="percentage_positive" position="top" />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div> */}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Syphilis Management
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    //stroke="#8884d8"
                    label={{
                      value: "",
                      angle: -90,
                      position: "outside",
                      offset: -100,
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />
                  <Bar
                    yAxisId="left"
                    dataKey="reactive"
                    fill="#00a084"
                    name="Syphilis Reactive"
                  >
                    <LabelList
                      dataKey="reactive"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="treated"
                    fill="#ffc40c"
                    name="Syphilis Treated"
                  >
                    <LabelList
                      dataKey="treated"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="treatmentgap"
                    fill="#dd1e47"
                    name="Treatment Gap"
                  >
                    <LabelList
                      dataKey="treatmentgap"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}

          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Percentage of Syphilis Positivity
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    //stroke="#8884d8"
                    label={{
                      value: "",
                      angle: -90,
                      position: "outside",
                      offset: -100,
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={["percentage_positive"]} />}
                  />

                  <Bar
                    yAxisId="left"
                    dataKey="percentage_positive"
                    fill="#dd1e47"
                    name="Percentage of Syphilis Positive"
                  >
                    <LabelList
                      dataKey="percentage_positive"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Percentage of Treated for Syphilis
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    //stroke="#8884d8"
                    label={{
                      value: "",
                      angle: -90,
                      position: "outside",
                      offset: -100,
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={["percentage_treated"]} />}
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="percentage_treated"
                    fill="#00a084"
                    name="Percentage of Syphilis Treated"
                  >
                    <LabelList
                      dataKey="percentage_treated"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Syphilis;
